import axios from '../services/request'
/* 获取学校 */
export const Index = (data = {}) => axios.get('api/school/index',data);

export default{
    Index
}